module.exports = __webpack_public_path__ + "img/block3.75b4af50.png";